import getField from '@form/formGenerator'

export const districtSaveUrl = `${import.meta.env.VITE_API_URL}/api/districts`

export const districtFormObject = {
  id: null,
  name: null,
  isActive: false
}

export const districtFormFields = (districtFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'name',
      label: t('labels.district_name'),
      value: districtFormObject.name,
      key: 'districtFormObject-name',
      cssClass: 'column is-12'
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: districtFormObject.isActive,
      cssClass: 'column is-12',
      key: 'districtFormObject-isActive',
      id: 'districtFormObject-isActive',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'districtFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(districtFormObject.id),
      key: 'districtFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}